module.exports = __webpack_public_path__ + "img/thanks.04869397.jpg";